import { postRequest } from '@/core';
import { incoterms } from '@/requests';

export default async function syncIncoterms() {
	let url = incoterms.getSyncPath();
	try {
		let response = await postRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}